import { styled } from 'styled-components';
import { ScInfoBtn } from '@/components/buttons/InfoButton/styled';
import { hexToRGB, screen, typography } from '@/styles/helpers';

export const overlayStyle = {
  opacity: '1',
  borderRadius: '12px',
  zIndex: 10,
  boxShadow:
    '0px 0px 12px 0px rgba(0, 0, 0, 0.60), 0px 0px 8px 0px rgba(0, 0, 0, 0.20)',
};

export const ScBonusShopBalance = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  height: 43px;
  padding: 0 8px;
  box-shadow: inset 0 0 0 1px ${({ theme }) => hexToRGB(theme.whiteColor, 0.2)};
  border-radius: 360px;
  background-color: ${({ theme }) => theme.grayDarkColor};

  @media (${screen.md}) {
    height: 48px;
    padding: 0 12px;
  }

  @container bonus-shop-heading (max-width: 355px) {
    padding: 0 8px 0 12px;

    & > img {
      display: none;
    }
  }

  & .info {
    display: flex;
    flex-direction: column;
  }

  ${ScInfoBtn} {
    margin-left: 4px;
  }

  & .label {
    color: ${({ theme }) => theme.whiteColor};
    ${typography.caption2regular}

    @media (${screen.md}) {
      font-size: 12px;
    }
  }

  & .value {
    display: block;
    margin-top: -2px;
    color: ${({ theme }) => theme.secondaryColor};
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 0.14px;
    white-space: nowrap;

    @media (${screen.md}) {
      margin-top: 0;
      ${typography.headline3}
    }
  }
`;

export const ScBonusShopBalanceTooltip = styled.div`
  & .tooltip-title {
    font-size: 12px;
    font-weight: 700;
    line-height: 24px;
  }

  & .tooltip-text {
    font-size: 12px;
    line-height: 14px;
  }

  & .tooltip-link {
    display: inline-block;
    margin-top: 14px;
    padding: 0;
    background: none;
    color: ${({ theme }) => theme.secondaryColorHover};
    font-size: 12px;
    line-height: 14px;
    text-align: left;
    text-decoration: underline;
    cursor: pointer;
  }
`;
